import { api } from './client.js';

export const rentalsApi = {
  listForCar: (carId) => api(`/rentals?car_id=${encodeURIComponent(carId)}`),
  get: (id) => api(`/rentals/${id}`),
  create: (formData) => api('/rentals', { method: 'POST', form: formData }),
  update: (id, body) => api(`/rentals/${id}`, { method: 'PATCH', body }),
  close: (id, body = {}) => api(`/rentals/${id}/close`, { method: 'POST', body }),
  sign: (id, body) => api(`/rentals/${id}/sign`, { method: 'POST', body }),
  sendForSigning: (id, body = {}) => api(`/rentals/${id}/send-for-signing`, { method: 'POST', body }),
  runOcr: (id) => api(`/rentals/${id}/ocr`, { method: 'POST' }),
  remove: (id) => api(`/rentals/${id}`, { method: 'DELETE' }),
  fileUrl: (id, slot) => `/api/files/rentals/${id}/${slot}`, // slot: 'id' | 'permis'
};
